import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group/tile flex gap-5 md:gap-6',
    imageWrapper: 'relative block size-25 shrink-0 md:size-30',
    image: 'w-full',
    label: 'absolute top-1 left-1',
    contentWrapper: 'flex grow flex-col justify-between gap-2 md:gap-3',
    text: 'md:ml-4',
    title: 'heading-s-bold md:heading-m-bold line-clamp-1 text-balance',
    subtitle: 'heading-xs md:heading-m line-clamp-1 text-pretty md:mt-1'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
